















import { formatCurrency } from "@/utility/Formatter";
import Vue from "vue";

// Vue Components
import InstallationTreePathWithResumeDialog from "@/components/InstallationTreePathWithResumeDialog.vue";
import TransactionPropsList from "@/components/PropsLists/TransactionPropsList.vue";
import CashDetailsCard from "./CashDetailsCard.vue";

// Model
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { Transaction } from "@/model/data/cashFlow/Transaction";
import { TransactionFlowEnum } from "@/model/data/enums/TransactionFlowEnum";
import { mapGetters } from "vuex";

export default Vue.extend({
    components: {
        TransactionPropsList,
        CashDetailsCard,
        InstallationTreePathWithResumeDialog,
    },
    data() {
        return {
            TransactionFlowEnum,
        };
    },
    props: {
        transaction: Transaction,
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        isUserAllowedToSeeDataflowFeedbacks() {
            return this.authUserHasPrivilege(ClientPrivileges.DataFlowFeedbacksViewer);
        },
    },
    methods: {
        formatCurrency,
    },
});
